App.UserTable = class extends App.DataTable {
  constructor(table) {
    const dataSourceUrl = '/users/data_table';

    const columns = [
      {
        sortable: false,
        render: function ( data, type, full, meta ) {
          var editLink = "/users/" + full.id + "/edit";
          return '<a href="'+editLink+'" class="btn btn-xs btn-muted-blue" >Edit</a>';
        },
        width: '48px'
      },
      {
        data: "full_name",
        className: 'all',
        width: '120px'
      },
      {
        data: "email",
        className: 'all',
        width: '120px'
      },
      {
        data: "member_roles",
        // Join and pull property from roles collection
        render: "[, ].name",
        width: '126px'
      },
      {
        data: "organization_names",
        name: "organization_names",
        visible: false,
        sortable: false
      },
      { data: "primary_interest_area" },
      {
        data: "status",
        name: "status"
      },
      {
        data: "current_sign_in_at",
        render: function( data, type, full, meta ) {
          var date = Date.parse(full.current_sign_in_at);
          return isNaN(date) ? '' : new Date(full.current_sign_in_at).toLocaleDateString("en-US");
        }
      },
      // Admin only
      {
        name: 'impersonate',
        sortable: false,
        visible: false,
        render: function (data, type, full, meta) {
          var link = "/users/" + full.id + "/impersonate";
          return full.confirmed_at ? '<a href="'+link+'" data-turbo="false" class="btn btn-xs btn-muted-blue">Impersonate</a>' : '';
        }
      }
    ];

    var searchFilterHtml = {
      'filter-status': "<select class='form-control input-sm'><option value=''>Any</option><option selected='selected'>Enabled</option><option>Disabled</option>"
    };

    super({ 
      table: table, 
      dataSourceUrl: dataSourceUrl, 
      columns: columns, 
      searchFilterHtml: searchFilterHtml,
      ajax: {
        url: dataSourceUrl,
        type: 'GET',
        beforeSend: function(xhr) {
          xhr.setRequestHeader(
            'X-CSRF-Token',
            document.querySelector('meta[name="csrf-token"]').content
          );
        }
      }
    });

  }

  /**
   * Initialize the datatable to only display the users with a Status column of "Enabled"
   */
  setupInitialTable() {
    //console.log(document.querySelector('meta[name="csrf-token"]').content);
    // Column in the table has a class of "select-filter"
    if($("#filter-status").hasClass("select-filter")) {
      $("#user_list").DataTable().column('status:name').search('Enabled').draw();
    }
  }

  afterDataLoad(e, settings, json, xhr) {
    if(json.current_user.can_impersonate) {
      $('#user_list')
        .DataTable()
        .column('impersonate:name')
        .visible(true);
      }
    if(json.current_organization == null) {
      $('#user_list')
        .DataTable()
        .column('organization_names:name')
        .visible(true);
    }
  }

  /**
   * Initialize the datatable to query the server for data with the columns in order
   */
  setupTableEvents() {
    /**
     * Search member list by permissions
     */
    var searchPermissions = function() {
      var permissionFields = $('#permissions_search_container select, #permissions_search_container input')
      var permissionParams = '?' + permissionFields.serialize();

      // reload datatable with new params
      $('#user_list')
        .DataTable()
        .ajax
        .url( permissionParams )
        .load();

      return false;
    }

    /**
    * Actions: Click row
    * When a row is clicked, go to the user's profile page
    */
    var clickRow = function(event) {
      var rowUserData     = this.table.DataTable().row(event.currentTarget).data();
      var userProfilePath = '/users/' + rowUserData.id;
      turbo.visit(userProfilePath);
    }


    /**
     * Actions: Click "Export CSV" button
     *   When the "Export CSV" button is clicked, collect the DataTable's ajax params and create form elements for
     * each of them. Then, submit the form with these new parameters to "users/csv_exports#create" so that the CSV
     * file can be generated
     */
    var clickExportCsv = function() {

      // remove existing form elements from the DOM in case we previously submitted
      $('[data-behavior="clear_on_next_submit"]').remove();

      // collect the various AJAX params that DataTables gives us and transform them into form elements
      var ajaxParams = $("#user_list").DataTable().ajax.params();

      const addInput = (name, value) => (
        $(this).append(
          $("<input />").
            attr('type', 'hidden').
            attr('name', name).
            attr('value', value).
            attr('data-behavior', 'clear_on_next_submit')
        )
      );

      addInput("draw", ajaxParams.draw);

      for (var i = 0; i < ajaxParams["columns"].length; i++) {
        addInput(`columns[${i}[data]`,          ajaxParams.columns[i].data);
        addInput(`columns[${i}[name]`,          ajaxParams.columns[i].name);
        addInput(`columns[${i}[searchable]`,    ajaxParams.columns[i].searchable);
        addInput(`columns[${i}[orderable]`,     ajaxParams.columns[i].orderable);
        addInput(`columns[${i}[search][value]`, ajaxParams.columns[i].search.value);
        addInput(`columns[${i}[search][regex]`, ajaxParams.columns[i].search.regex);
      }

      addInput("order[0][column]", ajaxParams.order[0].column);
      addInput("order[0][dir]", ajaxParams.order[0].dir);
      addInput("start", ajaxParams.start);
      addInput("length", ajaxParams.length);
      addInput("search[value]", ajaxParams.search.value);
      addInput("search[regex]", ajaxParams.search.regex);

      // submit the form after creating all of the form elements
      return true;

    };

    // Add events to table rows
    // this.table.find('tbody').on('click', 'tr', clickRow.bind(this));

    // Add events to permission search
    $('button#search_permissions').on('click', searchPermissions);

    // Add event to export csv button
    $('#users_csv_button').on('click', clickExportCsv);


    this.table.on('xhr.dt', this.afterDataLoad.bind(this));
  }
}

$(document).on('turbo:load', function() {
  if($(".users.index").length == 0) return;

  var userTable = new App.UserTable($("#user_list"));
  userTable.render();
  userTable.setupInitialTable();
  userTable.setupTableEvents();
});
